<template>
  <div class="stock-obv-view">
    <StockOBV />
  </div>
</template>

<script>
import StockOBV from '@/components/indicators/StockOBV.vue'

export default {
  name: 'StockOBVView',
  components: {
    StockOBV
  }
}
</script>

<style scoped>
.stock-obv-view {
  min-height: 100vh;
}
</style>
